import { ExternalLink, FileCode, Users, Wrench, Headphones, Check } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/blocks";
import { IMAGES } from "@/data/content";

const FILE_SERVICE_URL = "https://horsepowertuningfiles.com/";

const FEATURES = [
  { icon: FileCode, t: "Fichiers moteur", d: "Cartographies sur mesure pour chaque projet, développées par nos ingénieurs." },
  { icon: Wrench, t: "Solutions sur mesure", d: "Stage 1, 2, 3, E85, DPF/EGR options selon la législation et l'usage." },
  { icon: Users, t: "Ingénieurs dédiés", d: "Une équipe technique à vos côtés pour chaque demande." },
  { icon: Headphones, t: "Support technique", d: "Accompagnement, logs, corrections et suivi professionnel." },
];

export default function FileService() {
  return (
    <div data-testid="file-service-page">
      <Seo title="Horsepower Tuning Files | File Service professionnel"
        description="Horsepower Tuning Files : service de fichiers moteur pour professionnels. Cartographies sur mesure, ingénieurs dédiés, support technique et accompagnement."
        canonical="https://www.horsepowergarage.fr/file-service" />
      <PageHero eyebrow="Pour les professionnels" title="Horsepower Tuning Files"
        subtitle="Le File Service professionnel du réseau Horsepower : fichiers moteur sur mesure, ingénieurs et support technique."
        image={IMAGES.ecuLaptop} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((f, i) => (
            <Reveal key={f.t} delay={(i % 4) * 0.06}>
              <div className="hp-card p-7 h-full">
                <f.icon className="text-hp-yellow mb-4" size={28} />
                <h3 className="font-display font-bold uppercase tracking-tight text-lg">{f.t}</h3>
                <p className="text-neutral-400 text-sm mt-2 leading-relaxed">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="relative overflow-hidden bg-hp-yellow mt-16 p-10 sm:p-14 text-center">
            <div className="bg-grain absolute inset-0 opacity-10" />
            <div className="relative">
              <h2 className="font-display font-black uppercase tracking-tight text-3xl sm:text-4xl text-black">Accéder au File Service</h2>
              <p className="text-black/70 mt-3 max-w-xl mx-auto font-medium">Vous êtes un professionnel ? Rejoignez la plateforme Horsepower Tuning Files.</p>
              <a href={FILE_SERVICE_URL} target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-black text-hp-yellow font-display font-extrabold uppercase tracking-wide px-8 py-4 mt-7 hover:bg-neutral-900 transition-colors"
                data-testid="file-service-access">
                Accéder au File Service <ExternalLink size={18} />
              </a>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
